import api from "./api";

export const profileDetails = async (id: number) => {
    const { data } = await api.get(`profile/${id}`);

    return data
}

export const saveProfileDetails = async (id: number, params?: any) => {
    let formData = new FormData();
    formData.append("is_whatsapp", params?.is_whatsapp);
    formData.append("name", params?.name);
    formData.append("phone", params?.phone);
    formData.append("username", params?.username);
    
    if ((params?.picture === "" || typeof params?.picture === "object") && params.picture !== null) {
        formData.append("picture", params?.picture);
    }

    const { data } = await api.patch(`profile/${id}/`, formData);

    return data
}

export const passwordChange = async (params: any) => {
    const { data } = await api.post('password_change/', params);

    return data
}

export const mailChange = async (params: any) => {
    const { data } = await api.post('email_change/', params);

    return data
}

export const saveCompanyDetails = async (params: any, id?: number, ) => {
    if (id) {
        const { data } = await api.put(`company/${id}`, params);
        return data
    } else {
        const { data } = await api.post(`company/`, params);
        return data
    }
}

export const saveCompanyAddress = async (params: any, id?: number) => {
    if (id) {
        const { data } = await api.put(`address/${id}`, params);
        return data
    } else {
        const { data } = await api.post(`address/`, params);
        return data
    }
}

export const addCompanyToUser = async (userId: number, params?: any) => {
    const { data } = await api.put(`profile/${userId}/`, params);

    return data
}

export const requestSupportContact = async(params?: any) => {
    const { data } = await api.post('support_contact/', params);
    
    return data;
}


// Manager Services
export const managerProfileDetails = async (id: number) => {
    const { data } = await api.get(`manager/profile/${id}`);

    return data
}

export const managerUserChangePassword = async (id: number, params: any) => {
    const { data } = await api.put(`manager/profile/${id}/update_password/`, params);

    return data
}